import { render } from "./AltroCategoria.vue?vue&type=template&id=087dc5db"
import script from "./AltroCategoria.vue?vue&type=script&lang=js"
export * from "./AltroCategoria.vue?vue&type=script&lang=js"

import "./AltroCategoria.vue?vue&type=style&index=0&id=087dc5db&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__